<template>
  <v-list-tile
    class="white--text sidebar-menu my-0"
    @click="toggleCallbackWindow()"
  >
    <sidebar-item :hide-content="showOnlyIcon">
      <template v-slot:avatar>
        <v-icon v-if="!showOnlyIcon">
          {{ icon }}
        </v-icon>
        <v-btn icon v-else>
          <v-icon medium color="black">
            {{ icon }}
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:content v-if="!showOnlyIcon">
        <v-list-tile-title>
          <span> {{ supportLink ? $t("message.Callback.support") : $t("message.Callback.Request") }}</span>
        </v-list-tile-title>
      </template>
    </sidebar-item>
    <callback :supportlink="supportLink" ref="callbackDialog" />
  </v-list-tile>
</template>
<script>
import { VListTile, VListTileTitle, VIcon, VBtn } from 'vuetify/lib';
import { Validator } from 'vee-validate';
import { validationMessages } from 'Components/CallbackDialog/validationMessages';
import SidebarItem from 'Components/Sidebar/SidebarItem';
import Callback from 'Components/CallbackDialog/Callback';
import { mapGetters } from 'vuex';
Validator.localize(validationMessages);
export default {
  props: {
    showOnlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['portal']),
    supportLink() {
      if (this.portal && this.portal.portalDefaultConfig) {
        let portalDefaultConfig = JSON.parse(this.portal.portalDefaultConfig);
        if (portalDefaultConfig && portalDefaultConfig.supportLink) {
          return portalDefaultConfig.supportLink;
        }
      }
      return '';
    },
    icon() {
      return this.supportLink ? 'contact_support' : 'phone';
    }
  },
  data() {
    return {};
  },
  components: {
    VListTile,
    VListTileTitle,
    VIcon,
    SidebarItem,
    Callback,
    VBtn
  },
  methods: {
    toggleCallbackWindow() {
      this.$refs.callbackDialog.updateState();
    }
  }
};
</script>
